import {
  FORGOT_PASSWORD,
  FORGOT_PASSWORD_ERROR,
  FORGOT_PASSWORD_CLEAN,
  FORGOT_PASSWORD_CLEAN_ERROR,
} from '_models/redux/types';

const initialState = {
  forgotPassword: [],
  loading: false,
};

export default function forgotPasswordReducer(state = initialState, action) {
  switch (action.type) {
    case FORGOT_PASSWORD:
    case FORGOT_PASSWORD_CLEAN:
      return {
        ...state,
        forgotPassword: action.payload,
        loading: true,
      };
    case FORGOT_PASSWORD_ERROR:
    case FORGOT_PASSWORD_CLEAN_ERROR:
      return {
        ...state,
        forgotPassword: action.payload,
        loading: false,
      };
    default:
      return state;
  }
}
